import { Context } from "chartjs-plugin-datalabels";
import { Grid, Paper, Table, Typography, Box, TableContainer } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";
import { Chart, registerables } from 'chart.js';
import { Doughnut } from "react-chartjs-2";
import { TextQuestion } from "../../models/Question";
import { SentimentBar } from "../ui";
import { useState, useEffect } from "react";

// Registrar chart.js después de los imports
Chart.register(...registerables);

// import { ProgressBar } from "react-bootstrap"; // DELETE THIS
// import { MyMatrix, MyProgressBar } from '../../../../helpers/funtionsUtils/funtionsUtils';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: '24px',
  marginBottom: theme.spacing(3),
  color: theme.palette.text.primary,
  width: '100%',
  minWidth: 320,
  height: "auto",
  boxSizing: 'border-box',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#fff',
  borderRadius: '12px',
  border: '1.5px solid #e0e0e0',
  boxShadow: 'none',
}));

const containerStyle = {
  display: "flex",
  justifyContent: "center",
};

interface Props {
  index: number;
  question: TextQuestion;
}

function calculateChoiceValues(question: any): number[] {
  let choiceValues = [0, 0, 0];
  console.log("question: ", question);
  if (question !== undefined) {
    for (const x of question.sentimentScores) {
      if (x > 0.33) {
        if (x > 0.66) choiceValues[2]++;
        else choiceValues[1]++;
      } else choiceValues[0]++;
    }
  }
  console.log("choise: ", choiceValues);
  return choiceValues;
}

export function Type2QuestionChart({ index, question }: Props): JSX.Element {
  const [tooltip, setTooltip] = useState<{ visible: boolean; text: string; x: number; y: number }>({
    visible: false,
    text: '',
    x: 0,
    y: 0
  });

  // Ocultar tooltip al hacer scroll
  useEffect(() => {
    const handleScroll = () => {
      setTooltip({ visible: false, text: '', x: 0, y: 0 });
    };
    
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  // Utilidad para formatear como oración
  function toSentenceCase(text: string) {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  // Calcular valores de sentimiento para el gráfico de dona
  const sentimentCounts = calculateChoiceValues(question);
  console.log("sentimentCounts:", sentimentCounts);
  
  const sentimentData = {
    labels: ['Negative', 'Neutral', 'Positive'],
    datasets: [
      {
        data: sentimentCounts,
        backgroundColor: ['#FB5523', '#FDD835', '#6DAE43'],
        borderWidth: 0,
      },
    ],
  };

  const sentimentOptions = {
    onHover: (event: any, activeElements: any, chart: any) => {
      if (activeElements.length > 0) {
        const dataIndex = activeElements[0].index;
        const label = sentimentData.labels[dataIndex];
        const value = sentimentCounts[dataIndex];
        const total = sentimentCounts.reduce((sum, v) => sum + v, 0);
        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0.0';
        
        setTooltip({
          visible: true,
          text: `${label}: ${percentage}%`,
          x: event.native.clientX,
          y: event.native.clientY
        });
      } else {
        setTooltip({ visible: false, text: '', x: 0, y: 0 });
      }
    },
    onLeave: () => {
      setTooltip({ visible: false, text: '', x: 0, y: 0 });
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
      datalabels: {
        display: false
      }
    },
    responsive: true,
    maintainAspectRatio: true,
    cutout: '55%',
  };

  return (
    <>
      <span
        style={{
          fontSize: "18px",
          fontFamily: "IBM Plex Sans, sans-serif",
          fontWeight: 600,
          color: "#1A237E",
          margin: 0,
          marginBottom: 16,
          paddingTop: 0,
          display: 'block',
        }}
      >
        {index}. {question.title}
      </span>
      
      <Box sx={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        gap: '16px', 
        alignItems: 'flex-start' 
      }}>
        <Item style={{ 
          flex: 1, 
          minWidth: 0,
          alignItems: 'flex-start', 
          justifyContent: 'flex-start' 
        }}>
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table sx={{ minWidth: 300, background: "#fff", borderRadius: 2, boxShadow: 0, width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ 
                    textAlign: "left", 
                    color: "#1A237E", 
                    fontWeight: 600, 
                    fontSize: 16, 
                    padding: 8,
                    whiteSpace: 'nowrap'
                  }}>Answers</th>
                  <th style={{ 
                    textAlign: "center", 
                    color: "#1A237E", 
                    fontWeight: 600, 
                    fontSize: 16, 
                    padding: 8,
                    whiteSpace: 'nowrap'
                  }}>Sentiment</th>
                </tr>
              </thead>
              <tbody>
                {question.answers.map((answer, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? "#f6f8fc" : "#fff" }}>
                    <td style={{ 
                      padding: 8, 
                      fontSize: 15,
                      wordBreak: 'break-word',
                      maxWidth: '200px'
                    }}>{toSentenceCase(answer) || "(blank)"}</td>
                    <td style={{ padding: 8, textAlign: "center", minWidth: '120px' }}>
                      <SentimentBar score={question.sentimentScores[i]} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </Item>
        
        <Item style={{ 
          width: 'auto',
          minWidth: 240,
          maxWidth: 280,
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
            <Typography
              sx={{
                fontSize: 18,
                fontFamily: 'IBM Plex Sans',
                fontWeight: 600,
                color: '#1A237E',
                marginBottom: 0.5,
                alignSelf: 'flex-start',
                width: '100%'
              }}
            >
              Satisfaction
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                fontFamily: 'IBM Plex Sans',
                color: '#666',
                marginBottom: 3,
                alignSelf: 'flex-start',
                width: '100%'
              }}
            >
              Team feelings
            </Typography>
            <div 
              style={{ 
                width: '100%', 
                maxWidth: 220, 
                position: 'relative',
                margin: '0 auto'
              }}
              onMouseLeave={() => setTooltip({ visible: false, text: '', x: 0, y: 0 })}
            >
              <Doughnut data={sentimentData} options={sentimentOptions} />
            </div>
          
          {/* Leyenda personalizada */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '24px',
            marginTop: '35px',
            width: '100%'
          }}>
            {[
              { label: 'Negative', color: '#FB5523' },
              { label: 'Neutral', color: '#FDD835' },
              { label: 'Positive', color: '#6DAE43' }
            ].map((item, i) => (
              <div key={i} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px'
              }}>
                <div style={{
                  width: '32px',
                  height: '10px',
                  backgroundColor: item.color,
                  borderRadius: '2px'
                }} />
                <span style={{
                  fontFamily: 'IBM Plex Sans',
                  fontSize: '12px',
                  color: '#757575',
                  fontWeight: 400
                }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </Item>
      </Box>
      
      {tooltip.visible && (
        <div
          style={{
            position: 'fixed',
            left: tooltip.x + 10,
            top: tooltip.y + 10,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            color: '#fff',
            padding: '6px 10px',
            borderRadius: '4px',
            fontSize: '12px',
            fontFamily: "'IBM Plex Sans', sans-serif",
            zIndex: 10000,
            pointerEvents: 'none',
            maxWidth: '350px',
            wordWrap: 'break-word',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            lineHeight: '1.4'
          }}
        >
          {tooltip.text}
        </div>
      )}
    </>
  );
}
